import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Copyright } from "./signIn";
import { errorToast, infoToast, successToast } from "../Constants/Toast";
import { signUpAsync } from "../Constants/api";
import { UnprotectedRoute } from "./protectedComonent";
import { useNavigate } from "react-router-dom";

const defaultTheme = createTheme();

export default function SignInSide() {
  const navigate = useNavigate();
  const [emailError, setEmailError] = React.useState(null);
  const [passwordError, setPasswordError] = React.useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = React.useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const email = data.get("email");
    const password = data.get("password");
    const confirmPassword = data.get("Confirm password");

    let valid = true;

    // Reset error states
    setEmailError(null);
    setPasswordError(null);
    setConfirmPasswordError(null);

    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email address");
      valid = false;
    }

    // Validate password length
    if (password.length < 8) {
      setPasswordError("Password must be at least 8 characters");
      valid = false;
    }

    // Validate confirm password
    if (password !== confirmPassword) {
      setConfirmPasswordError("Password and confirm password do not match");
      valid = false;
    }

    if (!valid) {
      return;
    }

    signUpAsync({
      email: email,
      password: password,
    })
      .then((res) => {
        successToast(res.data);
        navigate("/signin");
      })
      .catch((err) => {
        errorToast(err);
      });
  };

  const handleEmailChange = (event) => {
    setEmailError(null);
  };

  const handlePasswordChange = (event) => {
    setPasswordError(null);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPasswordError(null);
  };

  return (
    <UnprotectedRoute>
      <ThemeProvider theme={defaultTheme}>
        <Grid container component="main" sx={{ height: "100vh" }}>
          <CssBaseline />
          <Grid
            item
            xs={false}
            sm={4}
            md={7}
            sx={{
              backgroundImage:
                'url("https://www.sae.edu/gbr/wp-content/uploads/sites/7/2023/12/Future-of-Film-SAE-1-1920x1256.jpg")',
              backgroundColor: (t) =>
                t.palette.mode === "light"
                  ? t.palette.grey[50]
                  : t.palette.grey[900],
              backgroundSize: "cover",
              backgroundPosition: "left",
            }}
          />
          <Grid
            item
            xs={12}
            sm={8}
            md={5}
            component={Paper}
            elevation={6}
            square
          >
            <Box
              sx={{
                my: 8,
                mx: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5" fontFamily={"Montserrat"}>
                Sign up
              </Typography>
              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit}
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  type="email"
                  error={!!emailError}
                  helperText={emailError}
                  onChange={handleEmailChange}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  error={!!passwordError}
                  helperText={passwordError}
                  onChange={handlePasswordChange}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="Confirm password"
                  label="Confirm Password"
                  type="password"
                  id="Confirm-password"
                  autoComplete="current-password"
                  error={!!confirmPasswordError}
                  helperText={confirmPasswordError}
                  onChange={handleConfirmPasswordChange}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Sign Up
                </Button>
                <Grid container>
                  <Grid item xs>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/resetpassword");
                      }}
                      href="/resetpassword"
                      variant="body2"
                    >
                      Forgot password?
                    </Link>
                  </Grid>
                  <Grid item>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/signin");
                      }}
                      href="/signin"
                      variant="body2"
                    >
                      {"Already have an account? Sign In"}
                    </Link>
                  </Grid>
                </Grid>
                <Copyright sx={{ mt: 5 }} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </ThemeProvider>
    </UnprotectedRoute>
  );
}
